let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lXmbw")).then(() => parcelRequire('1DcG0'));